import { expectValue } from './utilities'
import { PropsNumeralField } from './type'
import InputField from '../InputField'
import classNames from 'classnames'

export default function NumeralField({
    value = '',
    onChange = () => null,
    decimal = 0,
    min = null,
    max = 9999999999,
    negative = false,
    prefix = null,
    size = 'normal',
    fullWidth = true,
    className = '',
    readNumber = false,
    ...props
}: PropsNumeralField) {
    const options = {
        decimal,
        min,
        max,
        negative
    }

    function handleChange(ev) {
        const val = expectValue(ev.target.value, options)
        onChange({
            ...ev,
            target: {
                ...ev.target,
                value: val
            }
        })
    }

    return (
        <div className="relative">
            <InputField
                {...props}
                onChange={handleChange}
                value={!readNumber ? expectValue(value, options) : value}
                regex={null}
                size={size}
                className={classNames(
                    `${fullWidth && 'w-full'} ${prefix && 'pl-14'}`,
                    className
                )}
            />
            {prefix && (
                <div className="absolute bg-primary text-white top-0 left-0 px-4 py-3 text-xs rounded-l font-univers-bold">
                    {prefix}
                </div>
            )}
        </div>
    )
}
